export const formatNumber = (number, minPrecision = 2, maxPrecision = 2) => {
    if (number) {
        const options = {
            minimumFractionDigits: minPrecision,
            maximumFractionDigits: maxPrecision,
        };

        return number.toLocaleString("en-US", options)
    }
}
